import {useQuery} from '@apollo/client';
import {renderCurrencyList} from './FinancialCards';
import {MetricsEmpty} from './MetricsEmpty';
import {GET_VOLUME_METRIC} from 'graphql/queries/financial';
import {Form} from 'antd';
import styles from './financial.module.scss';
import {MetricsFilterBar} from './MetricsFilterBar';
import moment from 'moment';
import {ExportFinancialButton} from './ExportFinancialButton';
import {currentDayOfMonth, firstDayOfMonth} from './WalletMetrics';
import {useSelector} from 'react-redux';
import {NavTabsEnum} from 'utils/constants';
import {makeSelectTabOperations} from 'redux/store/auth';

export const VolumeMetrics = () => {
  const [form] = Form.useForm();
  const startDate = Form.useWatch('startDate', form);
  const endDate = Form.useWatch('endDate', form);
  const allTime = Form.useWatch('allTime', form);
  const status = Form.useWatch('status', form);

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Financials),
  );

  const {loading, data, refetch} = useQuery(GET_VOLUME_METRIC, {
    variables: {
      filters: {
        date: {
          range: 'MONTHLY',
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  const sections = (data?.getVolumeMetrics?.data || []).filter(
    section => section?.items?.length,
  );

  return (
    <>
      <MetricsFilterBar
        form={form}
        loading={loading}
        initialValues={{
          startDate: firstDayOfMonth,
          endDate: currentDayOfMonth,
        }}
        actions={
          tabOperations?.export ? (
            <ExportFinancialButton
              startDate={startDate}
              endDate={endDate}
              allTime={allTime}
              status={status}
              query={GET_VOLUME_METRIC}
              type="Order"
            />
          ) : null
        }
        onFinish={values => {
          if (values?.allTime) {
            return refetch({
              'filters': {
                'date': {
                  'range': 'MONTHLY',
                },
                'allTime': true,
                ...(values?.status && {status: values?.status}),
              },
            });
          }
          if (!values?.startDate && !values?.endDate) {
            return refetch({
              filters: {
                ...(values?.status && {status: values?.status}),
                date: {
                  range: 'MONTHLY',
                },
              },
            });
          }
          refetch({
            filters: {
              ...(values?.status && {status: values?.status}),
              date: {
                ...(values?.startDate && {
                  startDate: moment(values?.startDate).format(),
                }),
                ...(values?.endDate && {
                  endDate: moment(values?.endDate).format(),
                }),
              },
            },
          });
        }}
      />
      <div className={styles.metricCardsRow}>
        {loading
          ? Array(3)
              .fill('')
              .map((_, idx) => (
                <div key={idx} className={styles.metricCardBox}>
                  <div className={styles.metricCardList}>
                    {Array(3)
                      .fill('')
                      .map((data, key) => (
                        <div key={key} className={styles.loadingSkeleton}>
                          {data}
                        </div>
                      ))}
                  </div>
                </div>
              ))
          : sections.map(section => (
              <div key={section?.asset} className={styles.metricCardBox}>
                <h2 className={styles.sectionTitle}>{section?.asset}</h2>
                <div className={styles.metricCardList}>
                  {renderCurrencyList(section?.items, false, {
                    labelField: 'type',
                  })}
                </div>
              </div>
            ))}
        {/* Every asset with no volume used to render nothing at all, leaving
            the page blank below the filters with no way to tell an empty
            period from a failed load. */}
        {!loading && !sections.length && (
          <div className={styles.metricCardBox}>
            <MetricsEmpty>
              No traded volume for the filters you have applied.
            </MetricsEmpty>
          </div>
        )}
      </div>
    </>
  );
};
